import React from "react";
import { useTranslation } from 'react-i18next';
import { MdOutlineDangerous } from "react-icons/md";
import "../../styles/DeleteConfirmationModal.css";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    const { t } = useTranslation('common');

    if (!isOpen) return null;

    return (
        <div className="delete-confirmation-modal-overlay">
            <div className="delete-confirmation-modal-content">
                <div className="delete-confirmation-modal-header">
                    <div className="delete-confirmation-modal-header-info">
                        <h2 className="delete-confirmation-modal-title">{t('confirmation')}</h2>
                    </div>
                    <button className="delete-confirmation-close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="delete-confirmation-modal-body">
                    <div className="delete-confirmation-message">
                        <div className="delete-confirmation-icon">
                            <MdOutlineDangerous />
                        </div>
                        <p className="delete-confirmation-text">
                            {t('confirmDeleteItem', { itemName })}
                        </p>
                        <span className="delete-confirmation-subtext">
                            {t('actionIrreversible')}
                        </span>
                    </div>
                </div>

                <div className="delete-confirmation-modal-footer">
                    <button className="delete-confirmation-cancel-btn" onClick={onClose}>
                        {t('cancel')}
                    </button>
                    <button className="delete-confirmation-delete-btn" onClick={onConfirm}>
                        {t('delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
